import './Templates.css';
import api from '../api.js';
import { useEffect, useMemo, useState } from 'react';
import plus from '../imgs/plus.svg';

const DEMO_TEMPLATES = [
    {
        id: 1,
        partner: 'Интелмед',
        name: 'Напоминание о записи',
        gupshupTemplateId: 'appointment_reminder_v2',
        sourcePhone: '996700123456',
        content: 'Здравствуйте, {{1}}! Напоминаем о записи {{2}} в клинике Интелмед.',
        variableCount: 2,
        isMedia: false,
        isActive: true,
    },
    {
        id: 2,
        partner: 'Интелмед',
        name: 'Акция МРТ',
        gupshupTemplateId: 'promo_mrt_april',
        sourcePhone: '996700123456',
        content: 'Здравствуйте, {{1}}! До 30 апреля скидка 20% на МРТ. Запись: {{2}}',
        variableCount: 2,
        isMedia: true,
        isActive: true,
    },
];

const EMPTY_FORM = {
    partnerName: '',
    name: '',
    gupshupTemplateId: '',
    sourcePhone: '',
    content: '',
    variableCount: '0',
    isMedia: false,
};

export default function Templates() {
    const me = JSON.parse(localStorage.getItem('me') || '{}');
    const role = me?.userInfo?.role;
    const myPartnerName = me?.userInfo?.partnerName;

    const [templates, setTemplates] = useState([]);
    const [partners, setPartners] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState('');
    const [loading, setLoading] = useState(true);
    const [isDemo, setIsDemo] = useState(false);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [form, setForm] = useState(EMPTY_FORM);

    const loadTemplates = async (partnerFilter = selectedPartner) => {
        setLoading(true);
        setError('');

        try {
            const params = {};
            if (role === 'Админ' && partnerFilter) {
                params.partnerName = partnerFilter;
            }

            const res = await api.get('/api/templates/list', { params });
            setTemplates(res.data);
            setIsDemo(false);
        } catch {
            let demo = [...DEMO_TEMPLATES];

            if (role === 'Партнер' && myPartnerName) {
                demo = demo.filter((t) => t.partner === myPartnerName);
            } else if (role === 'Админ' && partnerFilter) {
                demo = demo.filter((t) => t.partner === partnerFilter);
            }

            setTemplates(demo);
            setIsDemo(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        document.title = 'Шаблоны - WAve';

        if (role === 'Админ') {
            api.get('/api/partners/list')
                .then((res) => {
                    setPartners(res.data);
                    if (res.data.length > 0) {
                        setSelectedPartner('');
                        setForm((f) => ({ ...f, partnerName: res.data[0].name }));
                    }
                })
                .catch(() => {});
        } else if (myPartnerName) {
            setForm((f) => ({ ...f, partnerName: myPartnerName }));
        }

        loadTemplates();
    }, []);

    useEffect(() => {
        if (!loading) {
            loadTemplates(selectedPartner);
        }
    }, [selectedPartner]);

    const previewText = useMemo(() => {
        if (!form.content.trim()) {
            return 'Введите текст шаблона для предпросмотра';
        }
        return form.content;
    }, [form.content]);

    const openCreate = () => {
        setError('');
        setMessage('');
        setForm({
            ...EMPTY_FORM,
            partnerName: role === 'Партнер'
                ? (myPartnerName || '')
                : (partners[0]?.name || ''),
        });
        setIsCreateOpen(true);
    };

    const closeCreate = () => {
        setIsCreateOpen(false);
        setError('');
        setMessage('');
    };

    const handleCreate = async (e) => {
        e.preventDefault();
        setProcessing(true);
        setError('');
        setMessage('');

        const payload = {
            partnerName: form.partnerName,
            name: form.name.trim(),
            gupshupTemplateId: form.gupshupTemplateId.trim(),
            sourcePhone: form.sourcePhone.trim(),
            content: form.content.trim(),
            variableCount: Number(form.variableCount),
            isMedia: form.isMedia,
        };

        if (isDemo) {
            const newItem = {
                id: Date.now(),
                partner: payload.partnerName,
                name: payload.name,
                gupshupTemplateId: payload.gupshupTemplateId,
                sourcePhone: payload.sourcePhone,
                content: payload.content,
                variableCount: payload.variableCount,
                isMedia: payload.isMedia,
                isActive: true,
            };
            setTemplates((prev) => [newItem, ...prev]);
            closeCreate();
            setMessage('Шаблон добавлен (демо-режим, API ещё не подключён)');
            setProcessing(false);
            return;
        }

        try {
            await api.post('/api/templates/create', payload);
            await loadTemplates();
            closeCreate();
            setMessage('Шаблон успешно создан');
        } catch (err) {
            setError(err?.response?.data || 'Ошибка при создании шаблона');
        } finally {
            setProcessing(false);
        }
    };

    return (
        <div className="templates-main">
            <div className="templates-top">
                <div>
                    <h1>
                        Шаблоны WhatsApp
                        {isDemo && <span className="demo-badge">Демо UI</span>}
                    </h1>
                    <p className="templates-subtitle">
                        Справочник одобренных шаблонов Gupshup. Укажите ID шаблона и номер source —
                        они понадобятся при создании рассылок.
                    </p>
                </div>
                <button type="button" className="createTemplate" onClick={openCreate}>
                    <span>Создать шаблон</span>
                    <img src={plus} alt="" />
                </button>
            </div>

            {role === 'Админ' && partners.length > 0 && (
                <div className="templates-filters">
                    <label>
                        Партнёр:
                        <select
                            value={selectedPartner}
                            onChange={(e) => setSelectedPartner(e.target.value)}
                        >
                            <option value="">Все</option>
                            {partners.map((p) => (
                                <option key={p.id} value={p.name}>{p.name}</option>
                            ))}
                        </select>
                    </label>
                </div>
            )}

            {error && !isCreateOpen && <p className="error">{error}</p>}
            {message && !isCreateOpen && <p className="success">{message}</p>}

            <div className="templates-table-wrapper">
                <table className="templates-table">
                    <thead>
                        <tr>
                            <th>Название</th>
                            <th>Партнёр</th>
                            <th>ID в Gupshup</th>
                            <th>Номер source</th>
                            <th>Переменных</th>
                            <th>Текст</th>
                            <th>Статус</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={7}>
                                    <span className="table-message">Загрузка...</span>
                                </td>
                            </tr>
                        ) : templates.length === 0 ? (
                            <tr>
                                <td colSpan={7}>
                                    <span className="table-message">Шаблонов пока нет</span>
                                </td>
                            </tr>
                        ) : (
                            templates.map((t) => (
                                <tr key={t.id}>
                                    <td>
                                        {t.name}
                                        {t.isMedia && <span className="status-media">Медиа</span>}
                                    </td>
                                    <td>{t.partner}</td>
                                    <td>{t.gupshupTemplateId}</td>
                                    <td>{t.sourcePhone}</td>
                                    <td>{t.variableCount}</td>
                                    <td className="content-cell" title={t.content}>{t.content}</td>
                                    <td>
                                        <span className="status-active">
                                            {t.isActive !== false ? 'Активен' : 'Выкл'}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {isCreateOpen && (
                <div className="modalOverlay">
                    <div className="modalTemplates">
                        <form onSubmit={handleCreate}>
                            <div className="modalTop">
                                <h3>Создать шаблон</h3>
                                <button type="button" onClick={closeCreate} aria-label="Закрыть" />
                            </div>

                            {role === 'Админ' && (
                                <div className="field">
                                    <label>Партнёр *</label>
                                    <select
                                        required
                                        value={form.partnerName}
                                        onChange={(e) => setForm({ ...form, partnerName: e.target.value })}
                                    >
                                        {partners.map((p) => (
                                            <option key={p.id} value={p.name}>{p.name}</option>
                                        ))}
                                    </select>
                                </div>
                            )}

                            <div className="field">
                                <label>Название *</label>
                                <input
                                    required
                                    placeholder="Например: Напоминание о записи"
                                    value={form.name}
                                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                                />
                            </div>

                            <div className="field">
                                <label>ID шаблона в Gupshup *</label>
                                <input
                                    required
                                    placeholder="appointment_reminder_v2"
                                    value={form.gupshupTemplateId}
                                    onChange={(e) => setForm({ ...form, gupshupTemplateId: e.target.value })}
                                />
                                <div className="field-hint">Имя шаблона, одобренного в Gupshup / Meta</div>
                            </div>

                            <div className="field">
                                <label>Номер WhatsApp (source) *</label>
                                <input
                                    required
                                    placeholder="996700123456"
                                    value={form.sourcePhone}
                                    onChange={(e) => setForm({ ...form, sourcePhone: e.target.value })}
                                />
                            </div>

                            <div className="field">
                                <label>Текст шаблона</label>
                                <textarea
                                    placeholder="Здравствуйте, {{1}}! Ваша запись: {{2}}"
                                    value={form.content}
                                    onChange={(e) => setForm({ ...form, content: e.target.value })}
                                />
                                <div className="field-hint">Для предпросмотра. Переменные: {'{{1}}'}, {'{{2}}'}...</div>
                            </div>

                            <div className="field">
                                <label>Количество переменных *</label>
                                <input
                                    type="number"
                                    min="0"
                                    max="10"
                                    required
                                    value={form.variableCount}
                                    onChange={(e) => setForm({ ...form, variableCount: e.target.value })}
                                />
                            </div>

                            <label className="checkbox-row">
                                <input
                                    type="checkbox"
                                    checked={form.isMedia}
                                    onChange={(e) => setForm({ ...form, isMedia: e.target.checked })}
                                />
                                Медиа-шаблон (с изображением)
                            </label>

                            <div className="preview-box">
                                <div className="preview-box-title">Предпросмотр</div>
                                <div className="preview-bubble">{previewText}</div>
                            </div>

                            {message && <p className="success">{message}</p>}
                            {error && <p className="error">{error}</p>}

                            <div className="buttonsModal">
                                <button
                                    type="submit"
                                    className="saveChangesPartners"
                                    disabled={processing}
                                >
                                    {processing ? 'Сохранение...' : 'Создать'}
                                </button>
                                <button
                                    type="button"
                                    className="cancelPartners"
                                    onClick={closeCreate}
                                    disabled={processing}
                                >
                                    Отмена
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
